// Categories for the pre-existing conditions questionnaire shown on step 1 once the
// "Vorerkrankung" coverage is selected. Mirrors the `categories` enum on the
// `PreexistingConditions` schema (openapi: array of these values, "other" requires
// `categoryComment` to be filled).

export type PreexistingConditionCategoryId =
  | "musculoskeletal"
  | "digestive"
  | "urogenital"
  | "cardiovascular"
  | "dermatology"
  | "endocrinology"
  | "other";

export interface PreexistingConditionCategoryDef {
  id: PreexistingConditionCategoryId;
  labelKey: string;
  infoTitleKey: string;
  infoDescriptionKey: string;
}

export const PREEXISTING_CONDITION_CATEGORIES: PreexistingConditionCategoryDef[] = [
  {
    id: "musculoskeletal",
    labelKey: "petDetails.preexistingConditionCategories.categories.musculoskeletal",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.musculoskeletal.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.musculoskeletal.description",
  },
  {
    id: "digestive",
    labelKey: "petDetails.preexistingConditionCategories.categories.digestive",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.digestive.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.digestive.description",
  },
  {
    id: "urogenital",
    labelKey: "petDetails.preexistingConditionCategories.categories.urogenital",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.urogenital.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.urogenital.description",
  },
  {
    id: "cardiovascular",
    labelKey: "petDetails.preexistingConditionCategories.categories.cardiovascular",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.cardiovascular.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.cardiovascular.description",
  },
  {
    id: "dermatology",
    labelKey: "petDetails.preexistingConditionCategories.categories.dermatology",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.dermatology.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.dermatology.description",
  },
  {
    id: "endocrinology",
    labelKey: "petDetails.preexistingConditionCategories.categories.endocrinology",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.endocrinology.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.endocrinology.description",
  },
  {
    id: "other",
    labelKey: "petDetails.preexistingConditionCategories.categories.other",
    infoTitleKey: "petDetails.preexistingConditionCategories.info.other.title",
    infoDescriptionKey: "petDetails.preexistingConditionCategories.info.other.description",
  },
];
